import React from 'react';
import LoadingWrapper from '@/components/LoadingWrapper';
import { usePageName } from '@/utils/log/hooks';

export default () => {
  const pageName = usePageName();
  // 启用了骨架屏的页面不需要默认的loading
  return ['home', 'product_detail', 'zzr_good_service_tab'].includes(
    pageName,
  ) ? null : (
    <div>
      <LoadingWrapper loading />
    </div>
  );
};
